const loginUseCase = (repository) => async (email, password) => {
  const jwtAuthToken = await repository(email, password)
  localStorage.setItem('auth', JSON.stringify(jwtAuthToken))
  return true
}

export default loginUseCase